// exclude-from-index
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { PropertyMarkerModel } from '../../../../Marker/Marker.model';
import Styled, {
  SingleListItemContainer,
  ImageContainer,
  InstantPropertyFlag,
  PropertyInfo,
  BookmarkButtonContainer,
  StyledPropertyImage
} from './PropertyListItem.styles';
import Text from '../../../../BuildingBlocks/Text';
import SVGIcon from '../../../../SVGIcon';
import ToolTip from '../../../../ToolTip/ToolTip';
import BookmarkSVG from '../../../../../public/static/assets/svg/bookmarkSVG';
import { colors } from '../../../../css';
import InstantPropertyBadge from '../../../../../public/static/assets/svg/instantPropertyBadge';

class PropertyListItem extends Component {
  static propTypes = {
    model: PropTypes.instanceOf(PropertyMarkerModel).isRequired,
    featureText: PropTypes.string,
    startingAtLabel: PropTypes.string,
    onClick: PropTypes.func,
    priceFrequencyLabel: PropTypes.string,
    updateFavourite: PropTypes.func,
    showFeatured: PropTypes.bool,
    showFavourite: PropTypes.bool,
    /**
     * Label if call for accurate pricing '/'
     */
    callForPricingLabel: PropTypes.string,
    /**
     * Label if loading '/'
     */
    loadingLabel: PropTypes.string,
    addFavouriteTooltipLabel: PropTypes.string,
    removeFavouriteTooltipLabel: PropTypes.string
  };

  static defaultProps = {
    featureText: 'Instant',
    startingAtLabel: 'Starting at',
    callForPricingLabel: 'Call for accurate pricing',
    loadingLabel: 'Getting current rate',
    onClick: () => {},
    priceFrequencyLabel: 'night',
    updateFavourite: () => {},
    showFeatured: true,
    showFavourite: false,
    addFavouriteTooltipLabel: `Make this a preferred property for your organization.\n
    Preferred properties always show up at the top in search results for all users in your organization.`,
    removeFavouriteTooltipLabel: 'Remove from Preferred Properties'
  };

  render() {
    const {
      model: {
        label,
        price,
        favourite,
        featured,
        active,
        currency,
        description,
        imgSrc,
        strikeoutPrice,
        callForPricing,
        availability,
        connected
      },
      featureText,
      priceFrequencyLabel,
      startingAtLabel,
      callForPricingLabel,
      loadingLabel,
      updateFavourite,
      showFavourite,
      showFeatured,
      onClick,
      addFavouriteTooltipLabel,
      removeFavouriteTooltipLabel
    } = this.props;
    const loading = connected && !availability;
    let availabilityText = '';
    if (availability === 'sold-out') {
      availabilityText = availability;
    } else if (availability === 'limited') {
      availabilityText = 'limited availability';
    }

    const favouriteTooltipLabel = favourite ? removeFavouriteTooltipLabel : addFavouriteTooltipLabel;

    const instantBookingTooltipLabel = `Instant Booking: <br>
    Typically confirmed faster, or instantly, depending on availability.`;

    return (
      <SingleListItemContainer
        role="button"
        className={`PropertyListItem${active ? ' active' : ''} ${availability}`}
        onClick={onClick}
      >
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <ImageContainer featured={featured}>
            <div className="placeholder">
              <SVGIcon selectedIcon="lodgelinkwhite" iconColor={colors.colorWhite} />
            </div>
            {imgSrc ? <StyledPropertyImage data-src={imgSrc} className="property-item-image" /> : null}
            {featured && showFeatured ? (
              <InstantPropertyFlag className="featured">
                <Text.CopyParagraph noMargins color="secondary" weight="bold">
                  {featureText}
                </Text.CopyParagraph>
              </InstantPropertyFlag>
            ) : null}
          </ImageContainer>
          <PropertyInfo>
            <Text.CopyMini tagName="p" color="tertiary" noMargins>
              {description}
            </Text.CopyMini>
            <Styled.Header>
              <Styled.HeaderLabel title={label} noMargins weight="bold" tagName="strong" className="notranslate">
                {label}
              </Styled.HeaderLabel>
            </Styled.Header>
            <Styled.LodgeInfo>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  {callForPricing || price === undefined || price === null ? (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                      <div>
                        <Text.CopyMini
                          className="callForPricingLabel"
                          noMargins
                          tagName="div"
                          textTransform="uppercase"
                        >
                          {callForPricingLabel}
                        </Text.CopyMini>
                        <Text.CopyMini weight="bold" tagName="span" color="quaternary">
                          {callForPricing}
                        </Text.CopyMini>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                      <div>
                        <Text.CopyMini noMargins tagName="div">
                          {startingAtLabel}
                          {strikeoutPrice && (
                            <Styled.StrikeoutPrice noMargins tagName="span" weight="bold">
                              {`${strikeoutPrice}`}
                            </Styled.StrikeoutPrice>
                          )}
                        </Text.CopyMini>
                        {loading ? (
                          <Styled.Loading textTransform="uppercase" weight="bold">
                            {loadingLabel}
                          </Styled.Loading>
                        ) : (
                          <>
                            <Styled.HeaderLabel weight="bold" tagName="span">
                              {price}
                            </Styled.HeaderLabel>
                            &nbsp;
                            <Styled.PriceLabel noMargins tagName="span">
                              <span>
                                {currency}/{priceFrequencyLabel}
                              </span>
                            </Styled.PriceLabel>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {loading ? (
                    <Styled.StyledSpinner size={12} thickness={8} />
                  ) : (
                    availabilityText &&
                    availability !== 'sold-out' && (
                      <div>
                        <Styled.LodgeStatus
                          className="lodge-status"
                          noMargins
                          tagName="div"
                          weight="bold"
                          textTransform="uppercase"
                          status={availability}
                        >
                          {availabilityText}
                        </Styled.LodgeStatus>
                      </div>
                    )
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <div style={{ display: 'flex', gap: '15px' }}>
                    {connected && (
                      <ToolTip content={instantBookingTooltipLabel} enableLineSpacing>
                        <InstantPropertyBadge enabled={connected} position="end" />
                      </ToolTip>
                    )}
                    <BookMarkMasterContainer
                      showFavourite={showFavourite}
                      updateFavourite={updateFavourite}
                      favouriteTooltipLabel={favouriteTooltipLabel}
                      favourite={favourite}
                    />
                  </div>
                </div>
              </div>
            </Styled.LodgeInfo>
          </PropertyInfo>
        </div>
      </SingleListItemContainer>
    );
  }
}

export default PropertyListItem;

// Added for code sanity, same instance is repeated in 2 instances

function BookMarkMasterContainer({ showFavourite, updateFavourite, favouriteTooltipLabel, favourite }) {
  return (
    <BookmarkButtonContainer>
      {showFavourite ? (
        <ToolTip content={favouriteTooltipLabel}>
          <BookmarkSVG selected={favourite} position="end" onClick={updateFavourite} />
        </ToolTip>
      ) : null}
    </BookmarkButtonContainer>
  );
}
